module.exports = __webpack_public_path__ + "img/avatar8.66af6f6b.jpg";